// extracted by mini-css-extract-plugin
module.exports = {"component":"ListViewColumn_component__QUogC","label":"ListViewColumn_label__HTPA1"};